import React from "react";
import ReactDOM from "react-dom";
import GasPass from "./GasPass";

// Init GasPass
ReactDOM.render( <GasPass />, document.body );
